import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="200" viewBox="0 0 100% 200" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.10" fill="#8E90A2">
            <rect x="0" y="0" width="100%" height="100%" rx="2" />
            <rect x="5%" y="20px" width="30%" height="30px" rx="2" />
            <rect x="80%" y="20px" width="15%" height="30px" rx="2" />
            <rect x="5%" y="65px" width="90%" height="1px" rx="2" />
            <rect x="5%" y="85px" width="90%" height="24px" rx="2" />
            <rect x="5%" y="115px" width="90%" height="24px" rx="2" />
        </g>
    </svg>
);

const CardLoadingIndicator = ({ shouldAnnounce = true, ...rest }) => (
    <RootWrapper {...rest}>
        {shouldAnnounce && <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>}
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default CardLoadingIndicator;
